import React from "react"
import { Card, Col, Row } from "reactstrap"
import { withTranslation } from "react-i18next"
import PropTypes from "prop-types"

//Import Image
import features from "../../assets/images/crypto/features-img/img-1.png"

const CardWelcome = props => {
  return (
    <React.Fragment>
      <Card>
        <div>
          <Row>
            <Col lg="9" sm="8">
              <div className="p-4">
                <h5 className="text-primary">
                  { props.t("contaspagar.cardwelcome.titulo") }
                </h5>
                <p>
                  { props.t("contaspagar.cardwelcome.descricao") }
                </p>

                <div className="text-muted">
                  <p className="mb-1">
                    <i className="mdi mdi-circle-medium align-middle text-primary me-1" />{ " " }
                    { props.t("contaspagar.cardwelcome.item1") }
                  </p>
                  <p className="mb-1">
                    <i className="mdi mdi-circle-medium align-middle text-primary me-1" />{ " " }
                    { props.t("contaspagar.cardwelcome.item2") }
                  </p>
                  <p className="mb-0">
                    <i className="mdi mdi-circle-medium align-middle text-primary me-1" />{ " " }
                    { props.t("contaspagar.cardwelcome.item3") }
                  </p>
                  <p className="mb-0">
                    <i className="mdi mdi-circle-medium align-middle text-primary me-1" />{ " " }
                    { props.t("contaspagar.cardwelcome.item4") }
                  </p>
                </div>
              </div>
            </Col>
            <Col lg="3" sm="4" className="align-self-center">
              <div>
                <img src={ features } alt="" className="img-fluid d-block" />
              </div>
            </Col>
          </Row>
        </div>
      </Card>
    </React.Fragment>
  )
}

CardWelcome.propTypes = {
  t: PropTypes.func,
}

export default withTranslation()(CardWelcome)
